module.exports = __webpack_public_path__ + "static/media/equal_pizza_pact.90809afe.pdf";